<template>
  <div class="view-blog">
    <div class="view-blog__content">
      <div class="view-blog__title-top hide-to-reveal">
        {{ titleTop }}
      </div>
      <h1 class="view-blog__title hide-to-reveal">
        {{ title }}
      </h1>

      <!-- content -->
      <div v-if="filteredPosts.length" class="view-blog__posts">
        <div class="view-blog__rows row">
          <div
            class="view-blog__row column"
            v-for="(post, idx) in currentPageItems"
            :key="post.id">
            <blog-post :first="idx === 0" :post="post"></blog-post>
          </div>
        </div>
      </div>
    </div>

    <!-- show more button -->
    <div
      v-if="
        filteredPosts.length > currentPageItems.length && totalPageCount > 1
      "
      class="pager__item">
      <a
        @click.prevent="setPage(currentPage + 1)"
        class="button button--secondary">
        <span class="button__text">{{ t.blog.loadMore }}</span>
      </a>
    </div>
  </div>
</template>

<script>
// @todo this is the same code as Projects.vue
// 3rd
import 'url-search-params-polyfill';
// components
import BlogPost from './BlogPost';
// utils
import initObserver from '../js/utils/reveal';
import scrollFader from '../js/elements/horizontalSwipeOverlay';
import translationStrings from '../js/utils/translationStrings';

export default {
  name: 'blog',
  components: {
    BlogPost,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    titleTop: {
      type: String,
      required: true,
    },
    filters: {
      type: Object,
      required: true,
    },
    posts: {
      type: Array,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      activeCategoryId: 0,
      defaultCategoryId: 0,
      urlParams: new URLSearchParams(window.location.search),
      currentPage: 0,
      totalPageCount: 0,
      currentPageItems: [],
      itemsPerPage: 7,
      t: translationStrings,
    };
  },
  computed: {
    filteredPosts() {
      return Object.values(this.posts).filter((post) => {
        // Return all posts.
        if (this.activeCategoryId === this.defaultCategoryId) {
          return true;
        }

        // filter posts that match category
        if (this.activeCategoryId && post.categories) {
          return post.categories.some(
            (cat) => cat.id === this.activeCategoryId,
          );
        }

        return false;
      });
    },
  },
  watch: {
    filteredPosts(val, oldVal) {
      // Update URL params with active filter selection
      // but only after initial value has been computed
      if (oldVal.length) {
        this.setUrlParams();
      }
    },
    activeCategoryId() {
      this.currentPage = 0;
      this.resetPager();
    },
  },
  mounted() {
    this.defaultCategoryId = Object.values(this.filters.categories)[0].id;

    // check URL for params
    this.urlParams.toString()
      ? this.parseUrlParams()
      : (this.activeCategoryId = this.defaultCategoryId);

    // reset pager
    this.resetPager();

    // Init reveal util.
    this.$nextTick(initObserver);

    // Init categories scroll (for mobile).
    scrollFader();
  },
  methods: {
    countEntries(id) {
      return Object.values(this.posts).reduce((acc, curr) => {
        if (
          (curr.categories && curr.categories.some((cat) => cat.id === id)) ||
          (id === 0 && curr.categories)
        ) {
          const increase = (acc += 1);
          return increase;
        }

        return acc;
      }, 0);
    },
    handleCategoryClick(id) {
      this.activeCategoryId = id;
      this.$nextTick(initObserver);
    },
    setUrlParams() {
      this.urlParams = new URLSearchParams({
        category: this.getCategoryMachineName(this.activeCategoryId),
      });
      // Update URL with new URL params.
      history.replaceState(
        null,
        '',
        this.urlParams.toString()
          ? `?${this.urlParams.toString()}`
          : window.location.pathname,
      );
    },
    parseUrlParams() {
      this.urlParams.forEach((param) => {
        this.activeCategoryId = this.getCategoryIdByName(param);
      });
    },
    getCategoryMachineName(id) {
      const category = Object.values(this.filters.categories).find(
        (cat) => cat.id === id,
      );
      return category?.machine_name || null;
    },
    getCategoryIdByName(machineName) {
      const category = Object.values(this.filters.categories).find(
        (cat) => cat.machine_name === machineName,
      );
      return category?.id || 0;
    },
    setPage(page) {
      this.currentPage = page;
      this.currentPageItems = this.filteredPosts.slice(
        0,
        this.currentPage * Number(this.itemsPerPage - 1) +
          Number(this.itemsPerPage),
      );
      this.$nextTick(initObserver);
    },
    resetPager() {
      this.totalPageCount = Math.ceil(
        this.filteredPosts.length / Number(this.itemsPerPage),
      );
      this.currentPageItems = this.filteredPosts.slice(
        0,
        Number(this.itemsPerPage),
      );
      this.$nextTick(initObserver);
    },
  },
};
</script>
